import { useTheme } from '@emotion/react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import InsightMarketSentiment from 'component/Common/InsightMarketSentiment';
import { poppins400, poppins700 } from 'theme/common.style';

export const MarketMetricsGraphOne = () => {
  const theme = useTheme();
  const matches400 = useMediaQuery(theme.breakpoints.down(400));

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#F5F6F7',
          padding: '20px',
          borderRadius: '8px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins !important',
            fontWeight: '600 !important',
            fontSize: '32px !important',
            color: '#112347 !important',
            textAlign: 'center',
            mb: '5px',
          }}
        >
          52
        </Typography>

        <InsightMarketSentiment value={52} />

        <Typography
          sx={{
            fontFamily: 'Poppins !important',
            fontWeight: '400 !important',
            fontSize: matches400 ? '16px' : '20px !important',
            color: '#112347 !important',
            textAlign: 'center',
            mb: '15px',
            mt: '5px',
          }}
        >
          Auction Clearance Rate
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#767676',
              }}
            >
              Auction Results - 2026
            </Typography>
            <Typography
              sx={{
                ...poppins700,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#112347',
              }}
            >
              52
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#767676',
              }}
            >
              Direct Comparable
            </Typography>
            <Typography
              sx={{
                ...poppins700,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#112347',
              }}
            >
              48
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export const MarketMetricsGraphTwo = () => {
  const theme = useTheme();
  const matches400 = useMediaQuery(theme.breakpoints.down(400));

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#F5F6F7',
          padding: '20px',
          borderRadius: '8px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins !important',
            fontWeight: '600 !important',
            fontSize: '32px !important',
            color: '#112347 !important',
            textAlign: 'center',
            mb: '5px',
          }}
        >
          34
        </Typography>

        <InsightMarketSentiment value={34} />

        <Typography
          sx={{
            fontFamily: 'Poppins !important',
            fontWeight: '400 !important',
            fontSize: matches400 ? '16px' : '20px !important',
            color: '#112347 !important',
            textAlign: 'center',
            mb: '15px',
            mt: '5px',
          }}
        >
          Average Days on Market
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#767676',
              }}
            >
              Overall Market - 2026
            </Typography>
            <Typography
              sx={{
                ...poppins700,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#112347',
              }}
            >
              34
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#767676',
              }}
            >
              Direct Comparable
            </Typography>
            <Typography
              sx={{
                ...poppins700,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#112347',
              }}
            >
              29
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export const MarketMetricsGraphThree = () => {
  const theme = useTheme();
  const matches400 = useMediaQuery(theme.breakpoints.down(400));

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#F5F6F7',
          padding: '20px',
          borderRadius: '8px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins !important',
            fontWeight: '600 !important',
            fontSize: '32px !important',
            color: '#112347 !important',
            textAlign: 'center',
            mb: '5px',
          }}
        >
          78
        </Typography>

        <InsightMarketSentiment value={78} />

        <Typography
          sx={{
            fontFamily: 'Poppins !important',
            fontWeight: '400 !important',
            fontSize: matches400 ? '16px' : '20px !important',
            color: '#112347 !important',
            textAlign: 'center',
            mb: '15px',
            mt: '5px',
          }}
        >
          Number of stock
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#767676',
              }}
            >
              Overall Market - 2026
            </Typography>
            <Typography
              sx={{
                ...poppins700,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#112347',
              }}
            >
              78
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#767676',
              }}
            >
              Direct Comparable
            </Typography>
            <Typography
              sx={{
                ...poppins700,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#112347',
              }}
            >
              61
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export const MarketMetricsGraphFour = () => {
  const theme = useTheme();
  const matches400 = useMediaQuery(theme.breakpoints.down(400));

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#F5F6F7',
          padding: '20px',
          borderRadius: '8px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins !important',
            fontWeight: '600 !important',
            fontSize: '32px !important',
            color: '#112347 !important',
            textAlign: 'center',
            mb: '5px',
          }}
        >
          Med
        </Typography>

        <InsightMarketSentiment value={50} />

        <Typography
          sx={{
            fontFamily: 'Poppins !important',
            fontWeight: '400 !important',
            fontSize: matches400 ? '16px' : '20px !important',
            color: '#112347 !important',
            textAlign: 'center',
            mb: '15px',
            mt: '5px',
          }}
        >
          Market sentiment
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#767676',
              }}
            >
              Overall Market - 2026
            </Typography>
            <Typography
              sx={{
                ...poppins700,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#112347',
              }}
            >
              Med
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#767676',
              }}
            >
              Direct Comparable
            </Typography>
            <Typography
              sx={{
                ...poppins700,
                fontSize: matches400 ? '14px' : '16px !important',
                color: '#112347',
              }}
            >
              Med
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};
